/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdatePaymentRequestEvidenceRequest
 */
export interface UpdatePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'electronicMethod'?: UpdatePaymentRequestEvidenceRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'documentSize'?: UpdatePaymentRequestEvidenceRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'dpiForciblyValid'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'colorGradationForciblyValid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentRequestEvidenceRequest
     */
    'asQualified'?: boolean | null;
}

export const UpdatePaymentRequestEvidenceRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceRequestElectronicMethodEnum = typeof UpdatePaymentRequestEvidenceRequestElectronicMethodEnum[keyof typeof UpdatePaymentRequestEvidenceRequestElectronicMethodEnum];
export const UpdatePaymentRequestEvidenceRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UpdatePaymentRequestEvidenceRequestDocumentSizeEnum = typeof UpdatePaymentRequestEvidenceRequestDocumentSizeEnum[keyof typeof UpdatePaymentRequestEvidenceRequestDocumentSizeEnum];


